//export const IPFS_PROVIDER = "https://mellori-v2.infura-ipfs.io/ipfs/"
export const IPFS_PROVIDER = "https://ipfs.chaintek.net/ipfs/"
